// extracted by mini-css-extract-plugin
export default {"modal":"ThirdPartyModal__modal___AdKci"};